export default __webpack_public_path__ + "static/success-d7fa1d632f50a4cc32f3890d19281169.webp";